module.exports = __webpack_public_path__ + "img/W-M64.b42d1c0e.jpg";